import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as MicrosoftDynamicsLogo } from 'Assets/svg/export_icons/microsoft_dynamics.svg';
import CRMExportHeader from './crmExportComponents';
import Input from '../newInputField';
import CancelSaveButton from '../CancelSaveButton';

class MicrosoftDynamicsExportState {
  @observable showPopup = false;

  @observable errorResponse = null;

  defaultPopupValue = {
    title: '',
    actionBtnText: 'Export',
    callback() {
      console.log('callback');
    },
  };

  defaultAuthValue = { resource_url: '' };

  @observable popupValues = this.defaultPopupValue;

  @observable authValues = this.defaultAuthValue;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val === false) this.popupValues = this.defaultPopupValue;
  };

  @action
  setErrorResponse = val => {
    this.errorResponse = val;
  };

  @action
  setPopupValues = val => {
    this.popupValues = { ...this.popupValues, ...val };
  };

  @action
  setAuthValues = (val = this.defaultAuthValue) => {
    console.log('def ', val);
    this.authValues = { ...this.authValues, ...val };
  };
}
const microsoftDynamicsExportState = new MicrosoftDynamicsExportState();

const MicrosoftDynamicsAuthenticationPopup = observer(props => {
  const defautState = JSON.parse(
    JSON.stringify(microsoftDynamicsExportState.authValues),
  );
  const [stateValues, setStateValues] = React.useState(defautState);
  const [errors, setErrors] = React.useState(defautState);

  const confirmClick = () => {
    const stateValueCopy = { ...stateValues };
    if (
      stateValueCopy.resource_url !== undefined &&
      stateValueCopy.resource_url !== ''
    ) {
      setErrors({ resource_url: false });
      microsoftDynamicsExportState.setAuthValues(stateValueCopy);
      microsoftDynamicsExportState.popupValues.callback(stateValueCopy);
      microsoftDynamicsExportState.setErrorResponse(null);
      microsoftDynamicsExportState.setShowPopup(false);
    } else {
      setErrors({ resource_url: !stateValues.resource_url });
    }
  };

  const setInputValues = (name, value) => {
    setErrors({
      ...errors,
      [name]: errors[name] !== '' ? !value : errors[name],
    });
    setStateValues({ ...stateValues, [name]: value });
  };

  React.useEffect(() => {
    if (microsoftDynamicsExportState.showPopup)
      setStateValues(
        JSON.parse(JSON.stringify(microsoftDynamicsExportState.authValues)),
      );
  }, [microsoftDynamicsExportState.showPopup]);

  return microsoftDynamicsExportState.showPopup ? (
    <>
      <div className="microsoftDynamicsAuthModal confirmation-popup common-popup">
        <section className="authContianer popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => microsoftDynamicsExportState.setShowPopup(false)}
          >
            <CloseIcon />
          </div>
          <CRMExportHeader
            Logo={MicrosoftDynamicsLogo}
            title="Microsoft Dynamics Export"
            message="Use your Microsoft Dynamics Resource URL for connecting with Adapt"
          />
          <div className="popup-body">
            <Input
              inputProps={{
                type: 'text',
                name: 'dynamicsResourceUrl',
                id: 'resource_url',
                placeholder:
                  'Example: https://resource-domain.crm8.dynamics.com',
                onChange: value => setInputValues('resource_url', value),
                value: stateValues.resource_url,
                required: true,
              }}
              className="api-key-wrap"
              error={errors.resource_url ? 'Please enter the resource URL' : ''}
              label="Resource URL"
            />
            {microsoftDynamicsExportState.errorResponse !== null &&
              microsoftDynamicsExportState.errorResponse.errorDescription !==
                undefined && (
                <div className="error-text show" id="errMarketo">
                  {microsoftDynamicsExportState.errorResponse.errorDescription}
                </div>
              )}
          </div>
          <div className="footer-section">
            <CancelSaveButton
              saveButtonText="Export"
              handleSave={confirmClick}
              handleCancel={() =>
                microsoftDynamicsExportState.setShowPopup(false)
              }
            />
          </div>
        </section>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => microsoftDynamicsExportState.setShowPopup(false)}
      />
    </>
  ) : (
    ''
  );
});

export default MicrosoftDynamicsAuthenticationPopup;
export { MicrosoftDynamicsAuthenticationPopup, microsoftDynamicsExportState };
